{
  "title": "Cash registers",
  "subtitle": "The registers of each store, the browser each one works on, and their shifts.",
  "status": {
    "open": "Open",
    "pendingApproval": "Variance to approve",
    "closed": "Closed"
  },
  "count": {
    "dinars": "{{value}} TND",
    "millimes": "{{value}} millimes",
    "quantityOf": "How many {{name}}",
    "total": "Total counted",
    "empty": "Nothing counted."
  },
  "device": {
    "is": "This browser is {{name}} · {{store}}",
    "shiftOpen": "Shift of {{cashier}}, open since {{time}}.",
    "noShift": "No shift open: count the float to open one.",
    "none": "This browser is not a cash register",
    "noneManager": "Pair it with one of the registers below to take money at a counter.",
    "noneHint": "A manager pairs the counter's browser with its register.",
    "goToShift": "Go to the shift",
    "open": "Open the shift",
    "pos": "Open the till"
  },
  "list": {
    "add": "Add register",
    "shifts": "Shifts",
    "inactive": "Not in use",
    "thisBrowser": "This browser",
    "nextReceipt": "Next receipt",
    "device": "On {{label}} · paired {{date}} by {{by}}",
    "noDevice": "No browser paired",
    "shiftOpen": "Shift of {{cashier}} open since {{time}}",
    "left": "{{amount}} left in the drawer",
    "neverOpened": "Never opened",
    "actions": "Actions on {{name}}",
    "edit": "Edit"
  },
  "empty": {
    "title": "No cash register yet",
    "text": "Add a register for each counter of your stores: it numbers its receipts and its Z reports."
  },
  "edit": {
    "newTitle": "New cash register",
    "title": "Edit {{name}}",
    "hint": "A register belongs to a store; its prefix numbers its receipts and its Z reports.",
    "name": "Name",
    "namePlaceholder": "Counter 1",
    "store": "Store",
    "prefix": "Receipt prefix",
    "prefixHint": "2 to 6 letters, used by no other document.",
    "active": "In use",
    "activeHint": "Out of use, it is no browser's register any more and opens no shift.",
    "create": "Add register",
    "created": "{{name}} added",
    "saved": "{{name}} saved"
  },
  "pair": {
    "action": "Pair this browser",
    "undo": "Unpair",
    "title": "Make this browser {{name}}",
    "hint": "Money taken on this browser will go into the register's open shift.",
    "replaces": "{{label}} is this register now: it will no longer be. A register works on one browser at a time.",
    "label": "What is this browser?",
    "labelHint": "So you know which device it is in the list.",
    "labelPlaceholder": "Counter PC",
    "confirm": "Pair this browser",
    "done": "This browser is now {{name}}",
    "undone": "{{name}} is no browser's register any more"
  },
  "open": {
    "title": "Open the shift of {{register}}",
    "hint": "Count the float note by note and coin by coin.",
    "count": "Float in the drawer",
    "left": "The previous shift left {{amount}} in the drawer.",
    "difference": "Difference:",
    "note": "Note",
    "confirm": "Open with {{amount}}",
    "done": "Shift open at {{register}}"
  },
  "movement": {
    "title": "Cash in or out of the drawer",
    "type": "Movement",
    "types": {
      "payIn": "Pay in",
      "payOut": "Pay out",
      "drop": "Drop to the safe"
    },
    "hints": {
      "payIn": "Money put in the drawer (change from the bank). Say where it comes from.",
      "payOut": "Money taken out of the drawer (a small purchase). Say what for.",
      "drop": "Money taken to the safe during the shift, so the drawer holds less."
    },
    "amount": "Amount",
    "reason": "Reason",
    "confirm": {
      "payIn": "Record the pay-in",
      "payOut": "Record the pay-out",
      "drop": "Record the drop"
    },
    "done": {
      "payIn": "{{amount}} put in the drawer",
      "payOut": "{{amount}} taken out of the drawer",
      "drop": "{{amount}} taken to the safe"
    }
  },
  "close": {
    "title": "Close the shift of {{register}}",
    "hint": "Count the drawer; the expected cash is shown as you count.",
    "blindHint": "Count the drawer: the expected cash shows once the count is in (blind count).",
    "count": "Cash in the drawer",
    "expectedNow": "Expected now: {{amount}}",
    "kept": "Left in the drawer",
    "keptHint": "For the next shift. {{amount}} goes to the safe.",
    "note": "Note",
    "limit": "A variance above {{amount}} waits for a manager to approve it.",
    "confirm": "Close the shift",
    "counted": "Counted",
    "expected": "Expected",
    "variance": "Variance",
    "toSafe": "To the safe",
    "closedTitle": "Shift closed",
    "closedText": "Z report {{number}} is issued.",
    "pendingTitle": "Shift closed, variance to approve",
    "pendingText": "The variance is above the limit: a manager approves it, then the Z report is issued.",
    "ok": "Done"
  },
  "approve": {
    "action": "Approve the variance",
    "title": "Approve the variance",
    "text": "{{cashier}}'s count differs from the expected cash. Say what you checked.",
    "note": "Why it is accepted",
    "confirm": "Approve and issue the Z report",
    "done": "Variance approved, Z report {{number}} issued"
  },
  "figures": {
    "xTitle": "X report",
    "closedTitle": "Figures at the closing",
    "method": "Method",
    "count": "Payments",
    "received": "Received",
    "refunded": "Refunded",
    "net": "Net",
    "none": "No payment in this shift yet.",
    "float": "Opening float",
    "expected": "Expected cash",
    "blind": "Shown after the count"
  },
  "movements": {
    "title": "Cash movements",
    "hint": "Pay-ins, pay-outs and drops to the safe.",
    "none": "No movement."
  },
  "shift": {
    "opened": "Opened {{time}}",
    "closed": "Closed {{time}}",
    "printX": "Print X report",
    "close": "Close the shift",
    "zReport": "Z report",
    "pendingTitle": "The variance waits for a manager",
    "pendingText": "The count is in. A manager approves the variance, then the Z report is issued.",
    "pendingManager": "Check the count, then approve the variance to issue the Z report.",
    "blind": "Blind count: the cash expected in the drawer shows once it is counted.",
    "opening": "Opening",
    "left": "Left by the previous shift",
    "openingDifference": "Difference at the opening",
    "closing": "Closing",
    "closedBy": "Counted by {{name}}",
    "approvedBy": "Approved by {{name}}"
  },
  "shifts": {
    "title": "Shifts",
    "subtitleAll": "Every shift of the registers of your stores, newest first.",
    "subtitleOwn": "Your shifts, newest first.",
    "register": "Register",
    "allRegisters": "All registers",
    "status": "Status",
    "allStatuses": "All statuses",
    "empty": "No shift yet",
    "emptyText": "Shifts appear here once a cashier opens one at a register.",
    "columns": {
      "register": "Register",
      "cashier": "Cashier",
      "opened": "Opened",
      "status": "Status",
      "counted": "Counted (TND)",
      "variance": "Variance (TND)"
    },
    "more": "Show more"
  },
  "z": {
    "immutable": "A Z report is issued once and never changes.",
    "print": "Print",
    "title": "Z report",
    "taxId": "Tax ID",
    "register": "Register",
    "cashier": "Cashier",
    "opened": "Opened",
    "closed": "Closed",
    "sales": "Payments by method",
    "drawer": "Drawer",
    "closedBy": "Counted and closed by {{name}}.",
    "approvedBy": "Variance approved by {{name}} on {{date}}",
    "amountsIn": "Amounts in Tunisian dinars (TND).",
    "issued": "Issued on {{date}}."
  },
  "till": {
    "into": "Taken at {{name}}: it goes into the shift of {{cashier}}.",
    "closedTitle": "This browser is {{name}} and its shift is not open",
    "closedText": "Money taken at a register goes into its open shift.",
    "open": "Open the shift"
  }
}
